import { render, staticRenderFns } from "./AskNoaButton.vue?vue&type=template&id=4c88f4e9"
import script from "./AskNoaButton.vue?vue&type=script&lang=js"
export * from "./AskNoaButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports